import { DISPUTED_MATCH_LIST_UPDATE } from '../actions/disputes';
import { Match } from '../../../models/Match';

const initialState = {
	disputedMatchList: new Map(),
};

export default (state = initialState, action) => {
	switch(action.type) {
		case DISPUTED_MATCH_LIST_UPDATE: {
			const matchList = new Map();
			const matches = action.payload;
			_.each(matches, (match, i) => {
				if(!Number.parseInt(i)) {
					return;
				}
				match = Match.create(match);
				matchList.set(match.id, match);
			});
			return {
				...state,
				disputedMatchList: matchList,
			};
		}
		default:
			return state;
	}
}
